import * as types from "../actions/types/index";
import { setInitialState } from "../util/utility";

const INITIAL_STATE = setInitialState({
    username: null,
    promocode: null,
    promocodevalid:false,
    register: null,
    twoFactorAuth: null,
    twoFactorAuthVerifyOtp: null,
    login: null,
    forgotPassword: null,
    userDetails: null,
    yotiDetails: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.VALIDATE_USERNAME_REQUEST:
        case types.VALIDATE_PROMOCODE_REQUEST:
        case types.REGISTER_REQUEST:
        case types.TWO_FACTOR_AUTH_REQUEST:
        case types.TWO_FACTOR_AUTH_VERIFY_OTP_REQUEST:
        case types.LOGIN_REQUEST:
        case types.FORGOT_PASSWORD_REQUEST:
        case types.CHANGE_PASSWORD_REQUEST:
        case types.CHANGE_EMAIL_REQUEST:
        case types.UPLOAD_PROFILE_PICTURE_REQUEST:
        case types.YOTI_INTEGRATION_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.VALIDATE_USERNAME_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                username: action.payload.success
            };
        case types.VALIDATE_USERNAME_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                username: action.payload.response.error,
            };
        case types.VALIDATE_PROMOCODE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                promocodevalid: true,
                promocode: action.payload.success
            };
        case types.VALIDATE_PROMOCODE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                promocodevalid:false,
                promocode: action.payload.response.error,
            };
        case types.RESET_PROMOCODE:
            return {
                ...state,
                promocodevalid:false,
                promocode: action.payload,
            };
        case types.RESET_USERNAME:
            return {
                ...state,
                username: action.payload,
            };
        case types.REGISTER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                register: action.payload.success
            };
        case types.REGISTER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                register: action.payload.response.error,
            };
        case types.TWO_FACTOR_AUTH_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                twoFactorAuth: action.payload.success
            };
        case types.TWO_FACTOR_AUTH_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                twoFactorAuth: action.payload.response.error,
            };
        case types.RESET_TWO_FACTOR_AUTH:
            return {
                ...state,
                twoFactorAuth: action.payload
            };
        case types.TWO_FACTOR_AUTH_VERIFY_OTP_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                twoFactorAuthVerifyOtp: action.payload.success
            };
        case types.TWO_FACTOR_AUTH_VERIFY_OTP_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                twoFactorAuthVerifyOtp: action.payload.response.error,
            };
        case types.RESET_TWO_FACTOR_AUTH_VERIFY_OTP:
            return {
                ...state,
                twoFactorAuthVerifyOtp: action.payload
            }
        case types.RESET_REGISTER:
            return {
                ...state,
                register: action.payload,
            };
        case types.LOGIN_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                login: action.payload.success
            };
        case types.LOGIN_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                login: action.payload.response.error,
            };
        case types.RESET_LOGIN:
            return {
                ...state,
                login: action.payload,
            };
        case types.FORGOT_PASSWORD_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                forgotPassword: action.payload.success
            };
        case types.FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                forgotPassword: action.payload.response.error,
            };
        case types.RESET_FORGOT_PASSWORD:
            return {
                ...state,
                forgotPassword: action.payload,
            };
        case types.USER_DETAILS_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                userDetails: action.payload.data[0]
            };
        case types.USER_DETAILS_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                userDetails: action.payload.response.error,
            };
        case types.RESET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload
            };
        case types.CHANGE_PASSWORD_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                changePassword: action.payload.success
            };
        case types.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                changePassword: action.payload.response.error,
            };
        case types.CHANGE_EMAIL_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                changeEmail: action.payload.success
            };
        case types.CHANGE_EMAIL_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                changeEmail: action.payload.response.error,
            };
        case types.UPLOAD_PROFILE_PICTURE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                uploadProfilePicture: action.payload.success
            };
        case types.UPLOAD_PROFILE_PICTURE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                uploadProfilePicture: action.payload.response.error,
            };
        case types.RESET_UPLOAD_PROFILE_PICTURE:
            return {
                ...state,
                uploadProfilePicture: action.payload,
            };
        case types.YOTI_INTEGRATION_RECEIVE:
            return {
                ...state,
                isFetching: false,
                yotiDetails: action.payload
            };
        case types.YOTI_INTEGRATION_FAILURE:
            return {
                ...state,
                isFetching: false,
                yotiDetails: action.payload.response.error,
            };
        case types.RESET_YOTI_INTEGRATION:
            return {
                ...state,
                yotiDetails: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}